import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '../src/assets/style/common.scss'
import '../src/assets/style/animate.scss'
import '../src/assets/style/element-variables.scss'
import { dataSourceId, scHost } from '../src/assets/js/env';
import wehotelSensors from '../src/assets/js/wehotel.sensors.sdk';
import axios from 'axios'

// 接入神策
wehotelSensors.initSdk({
  dataSourceId: dataSourceId,
  server_url: scHost
})

Vue.prototype.axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.$success = function (success) {
  this.$message({
    duration: 1500,
    type: 'success',
    message: success
  });
};

Vue.prototype.$error = function (error) {
  if (store.state.errorCount == 0) {
    store.commit('errorCountIncrease');
    this.$alert(error, '', {
      type: 'error',
      showConfirmButton: false,
      closeOnClickModal: true,
      closeOnPressEscape: true,
      beforeClose: (action, instance, done) => {
        store.commit('errorCountDecrease');
        done();
      }
    });
  }
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js